module.exports = __webpack_public_path__ + "static/img/icon_zhongxing_jibing_yanjiu.49874a96.png";